module.exports = __webpack_public_path__ + "static/media/bnp.7e1aee7a.png";